import Http from "../libs/Http";

export const getCategories = async () => {
  const result = await Http({
    method: "GET",
    url: "https://fakestoreapi.com/products/categories",
  });
  return result;
};
export const getProductsInCategory = async (collection) => {
  return await Http.get(
    `https://fakestoreapi.com/products/category/${collection}`
  );
};

export const getLimitProducts = async (limit) => {
  return await Http.get(`https://fakestoreapi.com/products?limit=${limit}`);
};

export const getProduct = async (id) => {
  return await Http.get(`https://fakestoreapi.com/products/${id}`);
};
